"use client";

import { resolveMediaUrl } from "@/shared/helpers/media";

/**
 * Vídeo curto do painel de departamentos (`panel_video_*`), no lugar da arte.
 * Preenche o pai (`absolute inset-0`): quem usa dá o tamanho e o `relative`,
 * exatamente como a `MediaImage` com `fill` que ele substitui.
 *
 * Sem botão de som, ao contrário do `BannerVideo` da lib: é um mega-menu, o
 * vídeo é decorativo e some ao fechar o painel. `preload="metadata"` segura o
 * download até o painel abrir (o elemento só monta quando o departamento é
 * escolhido) e `autoPlay` só funciona com `muted` + `playsInline`.
 */
export function CategoryPanelVideo({ path, className }: { path: string; className?: string }) {
    const src = resolveMediaUrl(path);
    if (!src) return null;

    return (
        <video
            src={src}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            aria-hidden="true"
            className={`absolute inset-0 h-full w-full object-cover ${className ?? ""}`}
        />
    );
}
